export default {
  getBreakingPoint (parentNodeType, childNodeType) {
    if (parentNodeType === 'bpmn:Task' && childNodeType === 'bpmn:Task') {
      return 159
    } else if (parentNodeType === 'bpmn:Task' && childNodeType === 'bpmn:ExclusiveGateway') {
      return 120
    } else if (parentNodeType === 'bpmn:ExclusiveGateway' && childNodeType === 'bpmn:Task') {
      return 159
    }
    // parentNodeType === 'bpmn:ExclusiveGateway' && childNodeType === 'bpmn:ExclusiveGateway'
    return 120
  },
  createVerticalLine (parentId, childId, coordinates) {
    const { xStart, yStart, xEnd, yEnd } = coordinates
    const directionDown = yStart < yEnd
    const stretchCornerY = directionDown ? 5 : -5
    const stretchCornerX = 10
    const midX = xStart + (xEnd - xStart) / 2
    const midY = yStart + (yEnd - yStart) / 2
    const d = 'M' + xStart + ',' + yStart +
      ' Q' + (xStart + 22.5 + stretchCornerX) + ',' + (yStart - stretchCornerY) + ' ' + midX + ',' + midY +
      ' Q' + (xEnd - 22.5 - stretchCornerX) + ',' + (yEnd + stretchCornerY) + ' ' + xEnd + ',' + yEnd
    return d
  },
  createBackwardConnection (childIsStartNode, coordinates) {
    const { xStart, yStart, xEnd, yEnd, halfWidth } = coordinates
    const xSegment2 = xStart + halfWidth
    let ySegment3
    if (yStart > yEnd) {
      ySegment3 = yStart + 73
    } else {
      ySegment3 = yEnd + 73
    }
    const xSegment4 = xEnd - halfWidth
    const ySegment5 = yEnd + 10 * (childIsStartNode ? 1 : 0)
    const radius = Math.abs(this.getRadius(xStart, xEnd, halfWidth))
    const d = 'M' + xStart + ',' + yStart +
      ' L' + (xSegment2 - radius) + ',' + yStart +
      ' Q' + xSegment2 + ',' + yStart + ',' + xSegment2 + ',' + (yStart + radius) +
      ' L' + xSegment2 + ',' + (ySegment3 - radius) +
      ' Q' + xSegment2 + ',' + ySegment3 + ',' + (xSegment2 - radius) + ',' + ySegment3 +
      ' L' + (xSegment4 + radius) + ',' + ySegment3 +
      ' Q' + xSegment4 + ',' + ySegment3 + ',' + xSegment4 + ',' + (ySegment3 - radius) +
      ' L' + xSegment4 + ',' + (ySegment5 + radius) +
      ' Q' + xSegment4 + ',' + ySegment5 + ',' + (xSegment4 + radius) + ',' + ySegment5 +
      ' L' + xEnd + ',' + ySegment5
    return d
  },
  createForwardConnection (parentNodeType, coordinates) {
    let xSegment2
    const { xStart, yStart, xEnd, yEnd, halfWidth } = coordinates
    if (parentNodeType === 'bpmn:ExclusiveGateway') {
      xSegment2 = xStart + 25
    } else {
      xSegment2 = xEnd - halfWidth
    }
    const radius = this.getRadius(yStart, yEnd, halfWidth)
    // forward connection
    const d = 'M' + xStart + ',' + yStart +
      ' L' + (xSegment2 - Math.abs(radius)) + ',' + yStart +
      ' Q' + xSegment2 + ',' + yStart + ' ' + xSegment2 + ',' + (yStart + radius) +
      ' L' + xSegment2 + ',' + (yEnd - radius) +
      ' Q' + xSegment2 + ',' + yEnd + ' ' + (xSegment2 + Math.abs(radius)) + ',' + yEnd +
      ' L' + xEnd + ',' + yEnd
    return d
  },
  getConnectionCoordinates (parentNode, childNode) {
    let xStart = parentNode.x + 108 // width of event + offset (4px)
    const yStart = parentNode.y + 48
    let xEnd = childNode.x - 7 // offset for arrow
    const yEnd = childNode.y + 48 // Convert shape position coordinate of path
    const halfWidth = 45 / 2
    if (parentNode.type === 'bpmn:ExclusiveGateway') {
      xStart = parentNode.x + 105
    }
    if (childNode.type === 'bpmn:ExclusiveGateway') {
      xEnd = childNode.x - 2
    }
    return { xStart, yStart, xEnd, yEnd, halfWidth }
  },
  getRadius (yStart, yEnd, radius = 10) {
    const sign = Math.sign(yEnd - yStart)
    const res = Math.min(Math.abs(radius * Math.sign(yStart - yEnd)), Math.abs(yStart - yEnd) / 2)
    return res * sign
  }
}
